// ./src/pages/privates/User/styles.ts
import { Form } from '@unform/web';
import Modal from 'react-modal';
import styled from 'styled-components';

export const Container = styled.main`
  flex: 1;
  background-color: ${({ theme }) => theme.colors.whiteCloud.main};
`;

export const ContainerGroup = styled.div`
  flex: 1;
  display: flex;
`;

export const Content = styled.section`
  width: 100%;
  height: calc(100vh - 65px);
  background-color: ${({ theme }) => theme.colors.whiteCloud.main};
  padding: 3vh 4vw;
  overflow-y: auto;
`;

export const Estimates = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: 2vw;
  row-gap: 2vw;
  padding: 4vh 0;
  @media (max-width: 560px) {
    grid-template-columns: 1fr 1fr;
    row-gap: 2vw;
  }
  @media (max-width: 480px) {
    display: flex;
    flex-direction: column;
  }
`;

export const FormFilter = styled(Form)``;

export const ButtonsOption = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  .btn-update {
    max-width: 140px;
  }
  @media (max-width: 320px) {
    > button {
      width: 50px;
      > p {
        display: none;
      }
    }
  }
`;

export const FilterFieldSet = styled.div``;

export const FilterButtons = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 1vw;
  margin-top: 1.5vh;
`;

export const ModalSimpleFilter = styled(Modal)`
  background-color: ${({ theme }) => theme.colors.white.main};
  border-radius: 10px;
  box-shadow: 3px 3px 20px rgba(0, 0, 0, 0.1);
  border: 0.5px solid ${({ theme }) => theme.colors.black.opacity.low};
  max-height: 500px;
  max-width: 580px;
  width: 80%;
  padding: 8vh 4vw;
  margin: 15vh auto 0;
  position: relative;
  overflow: auto;
  @media (max-width: 539.9px) {
    width: 90%;
    padding: 6vh 6vw;
  }
`;
